import api from './api';

export const getAllLogistics = () => api.get('/logistics/allLogistics');
export const getClientsByLogistics = (logisticsId) => api.get(`/logistics/${logisticsId}/clients`);
export const getAllVials = () => api.get('/logistics/vials');
export const createLogisticsEntry = (payload) => api.post('/logistics/entry', payload);
export const getEntrySummary = (params) => api.get('/logistics/entry/summary', { params });
export const getEntryById = (entryId) => api.get(`/logistics/entry/${entryId}`);
export const getEntryForEdit = (entryId) => api.get(`/logistics/entry-edit/${entryId}`);
export const updateLogisticsEntry = (entryId, payload) =>
  api.post(`/logistics/entry/update/${entryId}`, payload);
export const downloadEntryExcel = (params) =>
  api.get('/logistics/entry/export', { params, responseType: 'blob' });


// Client Master
export const getClientList = () => api.get('/client-master/list');
export const createClient = (payload) => api.post('/client-master/create', payload);
export const getClientById = (id) => api.get(`/client-master/${id}`);
export const updateClient = (id, payload) => api.patch(`/client-master/update/${id}`, payload);
export const deleteClient = (id) => api.delete(`/client-master/delete/${id}`);

// Logistics Master
export const getLogisticsMasterList = () => api.get('/logistics/allLogistics');
export const createLogisticsMaster = (payload) => api.post('/logistics/create', payload);
export const getLogisticsMasterById = (id) => api.get(`/logistics/${id}`);
export const updateLogisticsMaster = (id, payload) =>
  api.patch(`/logistics/update/${id}`, payload);
export const deleteLogisticsMaster = (id) =>
  api.delete(`/logistics/delete/${id}`);


// Client Mapping
export const createClientMapping = (payload) =>
  api.post('/logistics/createMapping', payload);

export const getClientMappingList = () =>
  api.get('/logistics/mapping/list');

export const getClientMappingByLogistics = (logisticsId) =>
  api.get(`/logistics/mappingLogistics/${logisticsId}`);

export const deleteClientMapping = (id) =>
  api.delete(`/logistics/deleteMapping/${id}`);

export const regenerateLogisticsPassword = (id) =>
  api.post(`/auth/regenerate-password/${id}`);